<template>
    <v-dialog fullscreen persistent v-model="dialog">
        <v-card>
            <v-container>
                <v-layout row wrap>
                    <v-flex xs12 class="mt-3">
                        <h3 class="display-1 grey--text text--darken-2 text-xs-center">Disclaimer</h3>
                        <v-divider></v-divider>
                        <p>Creating a job requires permission from Cubo. By accepting this disclaimer, you understand that creating a job without permission could result in you not being paid for the work carried out.</p>
                    </v-flex>
                    <v-flex xs12 class="mt-3">
                        <v-layout row wrap>
                            <v-flex xs8>
                                <v-btn block class="success" @click="acceptDisclaimer">Accept</v-btn>
                            </v-flex>
                            <v-flex offset-xs1 xs3>
                                <v-btn block class="error" @click="declineDisclaimer">Decline</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
  export default {
    props: ['dialog'],
    data () {
      return {
      }
    },
    methods: {
      acceptDisclaimer () {
        this.$emit('update:dialog', false)
      },
      declineDisclaimer () {
        this.$router.push('/')
      }
    }
  }
</script>


// WEBPACK FOOTER //
// DisclaimerDialog.vue?69f5fd63